package one.healthium.profile.ui.food.components

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import one.healthium.base.utils.localizedMonthNames
import one.healthium.base.utils.toLocalDateTime
import one.healthium.ui.compose.components.cupertino.CalendarLocale
import one.healthium.ui.compose.components.cupertino.PlatformDateFormat
import kotlin.time.Instant

internal fun dateFormat() = LocalDateTime.Format {
    amPmHour()
    char(':')
    minute()
    char(' ')
    amPmMarker("AM", "PM")
    char('\n')
    char(' ')
    monthName(localizedMonthNames())
    char(' ')
    day()
    char(',')
    char(' ')
    year()
}

internal fun dateFormat24() = LocalDateTime.Format {
    hour()
    char(':')
    minute()
    char('\n')
    char(' ')
    day()
    char(' ')
    monthName(localizedMonthNames())
    char(' ')
    year()
}

fun formatDate(date: Instant, locale: CalendarLocale): String {
    return if (PlatformDateFormat.is24HourFormat(locale)) {
        date.toLocalDateTime().format(dateFormat24())
    } else {
        date.toLocalDateTime().format(dateFormat())
    }
}
